'use client';

import { faLocationDot } from '@fortawesome/pro-light-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Icon } from '@/components/ui/icon.component';
import { InstallmentTerms } from '@/components/ui/installment-terms.component';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { EntityProcedureSchedulePlace } from '@/app/(main)/(pages)/_components/entities/entity-procedure/entity-procedure-schedule-card.type';
import { SearchCardClinicTabs } from '@/app/(main)/(pages)/busca/[slug]/_components/search-schedules-list/search-card/variants/clinic/_components/tabs/search-card-clinic-tabs.component';

interface EntityProcedurePlaceCardProps {
  place: EntityProcedureSchedulePlace;
}

export function EntityProcedurePlaceCard({ place }: EntityProcedurePlaceCardProps) {
  const placeName = (
    <>
      <Icon icon={faLocationDot} className="size-4 shrink-0 text-green-500" />
      <Typography
        as="span"
        variant={TypographyVariant.BODY_TEXT}
        className="font-semibold text-green-500 [word-break:break-word]"
        data-testid={DataTestIdEnum.ENTITY_PROCEDURE_PLACE_CARD_NAME}
      >
        {place.name}
      </Typography>
    </>
  );

  return (
    <div
      className="flex w-full flex-col gap-4 rounded-2xl border border-gray-300 bg-white py-2"
      data-testid={DataTestIdEnum.ENTITY_PROCEDURE_PLACE_CARD}
    >
      <div className="flex items-center gap-2 py-2 pl-3 pr-4">{placeName}</div>

      <div
        className="border-y border-gray-300 px-3 py-4"
        data-testid={DataTestIdEnum.ENTITY_PROCEDURE_PLACE_CARD_SCHEDULES}
      >
        <SearchCardClinicTabs schedule={place.schedule} />
      </div>

      <div className="px-3">
        <InstallmentTerms
          totalPrice={place.totalPrice}
          dataTestId={DataTestIdEnum.ENTITY_PROCEDURE_PLACE_CARD_INSTALLMENT}
        />
      </div>
    </div>
  );
}
